import { render } from "./MarkMeteringSystemAsActiveForm.vue?vue&type=template&id=5993dbe7&scoped=true"
import script from "./MarkMeteringSystemAsActiveForm.vue?vue&type=script&lang=js"
export * from "./MarkMeteringSystemAsActiveForm.vue?vue&type=script&lang=js"

import "./MarkMeteringSystemAsActiveForm.vue?vue&type=style&index=0&id=5993dbe7&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5993dbe7"]])

export default __exports__